import React from 'react'

export default function Slider(props) {
    if (props.selected){
        return (
            <><input id={props.id} name={props.name} onClick={props.onClick} type="radio" defaultChecked data-gtm="filter" />
            <label htmlFor={props.id}>{props.value}</label> </>
        )
    } else {
        return (
            <><input id={props.id} name={props.name} onClick={props.onClick} type="radio" data-gtm="filter" />
            <label htmlFor={props.id}>{props.value}</label> </>
            )
    }
}